import SubscriptionTierService from 'src/modules/subscriptionTier/subscriptionTierService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/store';
import { i18n } from 'src/i18n';

const prefix = 'SUBSCRIPTIONTIER_FORM';

const subscriptionTierFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: subscriptionTierFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await SubscriptionTierService.find(id);
      }

      dispatch({
        type: subscriptionTierFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: subscriptionTierFormActions.INIT_ERROR,
      });

      getHistory().push('/subscription-tier');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: subscriptionTierFormActions.CREATE_STARTED,
      });

      await SubscriptionTierService.create(values);

      dispatch({
        type: subscriptionTierFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.subscriptionTier.create.success'),
      );

      getHistory().push('/subscription-tier');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: subscriptionTierFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: subscriptionTierFormActions.UPDATE_STARTED,
      });

      await SubscriptionTierService.update(id, values);

      dispatch({
        type: subscriptionTierFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.subscriptionTier.update.success'),
      );

      getHistory().push('/subscription-tier');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: subscriptionTierFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default subscriptionTierFormActions;
